<template>
  <div>
    <div
      class="bg-light"
      :key="componentKey"
    >
      <div v-if="!filteredTable || filteredTable.length == 0" class="my-2">
        <h6>Pas de filtre</h6>
      </div>
      <div v-else class="my-2">
        <div class="mx-2" bg-variant="info" v-for="(field, indexField) in filteredTable" :key="indexField">
          <hr/>
          <span class="d-block mb-1 font-weight-bold" style="font-size:0.9rem">{{ field.fieldName }}</span>
          <highcharts v-if="field.type == 'time'" :options="charted(field)" class="mb-2 chart"></highcharts>
          <template v-else-if="field.type == 'company'" class="mb-2" flush>
            <div
              v-for="(facet, indexFacet) in filteredFacets(field.facets, indexField)"
              :key="indexFacet"
              @click="$emit('clickFacet', facet)"
              class="py-0 d-flex justify-content-between align-items-center facet"
            >
              <span class="d-block mb-1 ml-3" style="font-size:1rem" v-html="company(facet.label)"></span>
              <span style="font-size:1rem"><b-badge>{{facet.total}}</b-badge></span>
            </div>
            
          </template>
          <template v-else class="mb-2" flush>
            <div
              v-for="(facet, indexFacet) in filteredFacets(field.facets, indexField)"
              :key="indexFacet"
              @click="$emit('clickFacet', facet)"
              class="py-0 d-flex justify-content-between align-items-center facet"
            >
              <span class="d-block mb-1 ml-3" style="font-size:1rem"><i>{{facet.label}}</i></span>
              <span style="font-size:1rem" class="mr-3"><b-badge>{{facet.total}}</b-badge></span>
            </div>
          </template>
          
          <a
              v-if="!expandedFacets[indexField] && field.facets.length > 3 && field.type !== 'time'"
              button
              @click.prevent="clickMore(indexField)"
              class="more d-block mb-1 ml-3" style="font-size:0.8rem"
              href=""

            >
              <i>Plus... ({{field.facets.length - 3}})</i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import { Chart } from "highcharts-vue";
import Strings from "@/services/String.js";
export default {
  name: "facets",
  components: {
    highcharts: Chart
  },
  props: {
    context: String,
    table: Array,
    title: {
      type: String,
      default: "Facettes"
    }
  },
  data() {
    return {
      componentKey: 0,
      expandedFacets: [],
      chartOptions: {
        series: [
          {
            data: [1, 2, 3] // sample data
          }
        ]
      }
    };
  },
  created() {
    this.expandedFacets = this.table.map(() => false);
  },
  computed: {
    filteredTable() {
      return this.table.filter( x => x.facets.length > 1);
    }
  },

  methods: {
    clickMore(index) {
      this.expandedFacets[index] = true;
      this.componentKey++;
    },
    filteredFacets(facets, index) {
      if (this.expandedFacets[index]) {
        return facets;
      } else {
        return facets.slice(0, 3);
      }
    },
    company(str) {
      return Strings.company(str);
    },
    charted(facet) {
      let mappedFacets = facet.facets.map(x => x);
      let min = mappedFacets[0].value;
      let max = mappedFacets[mappedFacets.length - 1].value;
      for (let i = min; i < max; i++) {
        if (mappedFacets.every(x => x.value !== i)) {
          mappedFacets.push({ value: i, total: 0 });
        }
      }
      let that = this;
      mappedFacets = mappedFacets.sort((a, b) => a.value - b.value);

      let chart = {
        credits: {
          enabled: false
        },
        chart: {
          height: 250,
          type: "line"
        },
        title: {
          text: ""
        },
        xAxis: {
          categories: mappedFacets.map(x => x.value),
          crosshair: true,
          title: {
            text: "Année"
          }
        },
        yAxis: {
          min: 0,
          title: {
            text: that.context
          }
        },
        plotOptions: {
          series: {
            cursor: "pointer",
            point: {
              events: {
                click: function() {
                  if (this.y > 0) {
                    that.$emit(
                      "clickFacet",
                      mappedFacets.filter(x => x.value == this.category)[0]
                    );
                  }
                }
              }
            }
          }
        },
        series: [
          {
            data: mappedFacets.map(x => x.total),
            name: "Nombre de " + that.context + " par année"
          }
        ]
      };
      return chart;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
.facet {
  transition: background-color 0.5s;
  cursor: pointer;
  &:hover {
    background-color: $info;
  }
}
.chart {
  border-radius: 4px;
}
</style>